export function mainNav() {
    function closeFilterMenu(e) {
        if (!document.querySelector('.header-filters-holder').contains(e.target) && !e.target.closest('.jcf-option')) {
            document.querySelector('.header-filters-holder').classList.remove('filters-open');
            window.removeEventListener('click', closeFilterMenu);
        }
    }

    function closeCategoriesMenu(e) {
        if (!document.querySelector('.categories-holder').contains(e.target)) {
            document.querySelector('.categories-holder').classList.remove('filters-open');
            window.removeEventListener('click', closeCategoriesMenu);
        }
    }

    $(".header-filters-holder .filter-opener").on("click", function (e) {
        e.preventDefault();
        const filterBox = $(this).parents(".header-filters-holder");
        filterBox.toggleClass("filters-open");
        if (filterBox.hasClass('filters-open')) {
            window.addEventListener('click', closeFilterMenu);
        } else {
            window.removeEventListener('click', closeFilterMenu);
        }
    });

    $(".header .categories-button").on("click", function (e) {
        e.preventDefault();
        const categoriesFilter = $(this).parents(".categories-holder");
        categoriesFilter.toggleClass("filters-open");
        if (categoriesFilter.hasClass('filters-open')) {
            window.addEventListener('click', closeCategoriesMenu);
        } else {
            window.removeEventListener('click', closeCategoriesMenu);
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/mainNav.js